// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__10DeH","subheader":"ReorderModal_subheader__8U-6n","listWrap":"ReorderModal_listWrap__2l0Rq"};